// extracted by mini-css-extract-plugin
export default {"ForgotPassword":"ForgotPassword_ForgotPassword__2O010","ForgotPasswordInner":"ForgotPassword_ForgotPasswordInner__Id2bl"};